/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Assets_TitleInputs */

const id_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const ms_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aset`)
};

const da_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const de_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const en_us2_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const es_es2_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const es_mx2_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const fil_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Asset`)
};

const fr_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const it_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const hu_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset-ek`)
};

const nl_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const no_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiendeler`)
};

const pl_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const pt_br2_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const pt_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const ro_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset-uri`)
};

const fi_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resurssit`)
};

const sv_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillgångar`)
};

const vi_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const tr_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assetler`)
};

const cs_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assety`)
};

const bg_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const ru_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ассеты`)
};

const uk_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const ar_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأصول`)
};

const hi_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसेट्स`)
};

const th_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แอสเซท`)
};

const ja_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセット`)
};

const zh_cn2_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源`)
};

const zh_hant1_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資源`)
};

const ko_items_assets_title = /** @type {(inputs: Items_Assets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에셋`)
};

/**
* | output |
* | --- |
* | "Assets" |
*
* @param {Items_Assets_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_assets_title = /** @type {((inputs?: Items_Assets_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Assets_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_assets_title(inputs)
	if (locale === "ms") return ms_items_assets_title(inputs)
	if (locale === "da") return da_items_assets_title(inputs)
	if (locale === "de") return de_items_assets_title(inputs)
	if (locale === "en-US") return en_us2_items_assets_title(inputs)
	if (locale === "es-ES") return es_es2_items_assets_title(inputs)
	if (locale === "es-MX") return es_mx2_items_assets_title(inputs)
	if (locale === "fil") return fil_items_assets_title(inputs)
	if (locale === "fr") return fr_items_assets_title(inputs)
	if (locale === "it") return it_items_assets_title(inputs)
	if (locale === "hu") return hu_items_assets_title(inputs)
	if (locale === "nl") return nl_items_assets_title(inputs)
	if (locale === "no") return no_items_assets_title(inputs)
	if (locale === "pl") return pl_items_assets_title(inputs)
	if (locale === "pt-BR") return pt_br2_items_assets_title(inputs)
	if (locale === "pt") return pt_items_assets_title(inputs)
	if (locale === "ro") return ro_items_assets_title(inputs)
	if (locale === "fi") return fi_items_assets_title(inputs)
	if (locale === "sv") return sv_items_assets_title(inputs)
	if (locale === "vi") return vi_items_assets_title(inputs)
	if (locale === "tr") return tr_items_assets_title(inputs)
	if (locale === "cs") return cs_items_assets_title(inputs)
	if (locale === "bg") return bg_items_assets_title(inputs)
	if (locale === "ru") return ru_items_assets_title(inputs)
	if (locale === "uk") return uk_items_assets_title(inputs)
	if (locale === "ar") return ar_items_assets_title(inputs)
	if (locale === "hi") return hi_items_assets_title(inputs)
	if (locale === "th") return th_items_assets_title(inputs)
	if (locale === "ja") return ja_items_assets_title(inputs)
	if (locale === "zh-CN") return zh_cn2_items_assets_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_assets_title(inputs)
	return ko_items_assets_title(inputs)
});
export { items_assets_title as "items.assets.title" }